/**
 * @file   src\components\MemberWantAd\WantAdMemberSTR.js
 * @brief  This file is responsible for UI components for stay ad creation for member user.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import WantAdLocation from "./WantAdLocation";
import WantAdRentPropertyTypes from "./WantAdRentPropertyTypes";
import WantAdShortRentMstHves from "./WantAdShortRentMstHves";
import WantAdRentMustHavePrivate from "./WantAdRentMustHavePrivate";
import WantAdNiceToHaves from "./WantAdNiceToHaves";
import WantAdCalendar from "./WantAdCalendar";
import WantAdConfirmation from "./WantAdConfirmation";
import WantAdBudget from "./WantAdBudget";
import WantAdDescription from "./WantAdDescription";
import { IS_PRIVATE_ROOM, STR_MIN_BUDGET } from "../../constants/common";
import { convertToNumber } from "../../helpers/validations";

const WantAdMemberSTR = (props) => {
  const {
    step,
    handleContinueButtonState,
    handleFormValues,
    formValues,
    clearPreviousStates,
    targetRef,
  } = props;
  const propertyType = _.get(formValues, "prprtyType", "");
  switch (step) {
    case 3:
      return (
        <WantAdLocation
          handleContinueButtonState={handleContinueButtonState}
          handleFormValues={handleFormValues}
          location={_.get(formValues, "location", null)}
          lat={_.get(formValues, "lat", null)}
          lng={_.get(formValues, "lng", null)}
          mapZoom={_.get(formValues, "mapZoom", null)}
          mapRadius={_.get(formValues, "mapRadius", null)}
          neighborHood={_.get(formValues, "neighborHood", null)}
          highSchool={_.get(formValues, "highSchool", null)}
          zip={_.get(formValues, "zip", null)}
          adType={_.get(formValues, "adType", null)}
          targetRef={targetRef}
          city={_.get(formValues, "city", null)}
          state={_.get(formValues, "state", null)}
          county={_.get(formValues, "county", null)}
          isGitchaAvailable={_.get(formValues, "isGitchaAvailable", null)}
          zipCode={_.get(formValues, "zipCode", null)}
          zipIdValues={_.get(formValues, "zipIdValues", null)}
        />
      );
    case 4:
      return (
        <WantAdCalendar
          handleContinueButtonState={handleContinueButtonState}
          handleFormValues={handleFormValues}
          sDate={_.get(formValues, "startDate", null)}
          eDate={_.get(formValues, "endDate", null)}
          adType={_.get(formValues, "adType", null)}
          dateType={convertToNumber(_.get(formValues, "dateType", null))}
          duration={_.get(formValues, "duration", null)}
          month={_.get(formValues, "month", null)}
          clearPreviousStates={clearPreviousStates}
        />
      );
    case 5:
      return (
        <WantAdRentPropertyTypes
          handleContinueButtonState={handleContinueButtonState}
          handleFormValues={handleFormValues}
          propertyType={_.get(formValues, "prprtyType", null)}
          adType={_.get(formValues, "adType", null)}
          clearPreviousStates={clearPreviousStates}
          prptySubTypes={_.get(formValues, "prptySubTypes", [])}
        />
      );
    case 6:
      if (convertToNumber(propertyType) === IS_PRIVATE_ROOM) {
        //render this component if Property type --> private room
        return (
          <WantAdRentMustHavePrivate
            handleContinueButtonState={handleContinueButtonState}
            handleFormValues={handleFormValues}
            accsPvtBthRm={_.get(formValues, "accsPvtBthRm", "")}
            alwPets={_.get(formValues, "alwPets", "")}
            adaAccess={_.get(formValues, "adaAccess", "")}
            pvtEntrnce={_.get(formValues, "pvtEntrnce", "")}
          />
        );
      } else {
        return (
          <WantAdShortRentMstHves
            handleContinueButtonState={handleContinueButtonState}
            handleFormValues={handleFormValues}
            noOfBedrooms={_.get(formValues, "noBedRm", null)}
            noOfBathrooms={_.get(formValues, "noBathRm", null)}
            noOfBeds={_.get(formValues, "noOfBeds", "")}
            alwPets={_.get(formValues, "alwPets", "")}
            adaAccess={_.get(formValues, "adaAccess", "")}
          />
        );
      }
    case 7:
      return (
        <WantAdNiceToHaves
          handleContinueButtonState={handleContinueButtonState}
          handleFormValues={handleFormValues}
          nice2Have={_.get(formValues, "nice2Have", [])}
          adType={_.get(formValues, "adType", [])}
        />
      );
    case 8:
      return (
        <WantAdBudget
          handleContinueButtonState={handleContinueButtonState}
          handleFormValues={handleFormValues}
          budgetMin={_.get(formValues, "minBdgt", "")}
          budgetMax={_.get(formValues, "maxBdgt", "")}
          STR_MIN_BUDGET={STR_MIN_BUDGET}
          STR_DEFAULT_BUDGET={[500, 1000]}
          STR_STEP_VALUE={50}
          adType={_.get(formValues, "adType", "")}
          budgetErrors={_.get(formValues, "wantAdValErrors", null)}
          errorUpdatedAt={_.get(formValues, "updatedAt", null)}
        />
      );
    case 9:
      return (
        <WantAdDescription
          handleContinueButtonState={handleContinueButtonState}
          handleFormValues={handleFormValues}
          adTitle={_.get(formValues, "adTitle", "")}
          adDescription={_.get(formValues, "adDesc", "")}
        />
      );
    case 10:
      return (
        <WantAdConfirmation
          handleContinueButtonState={handleContinueButtonState}
          formValues={formValues}
        />
      );
  }
};
export default WantAdMemberSTR;
